import React, { useState } from "react";

const ReferralView = ({ referralCode, s30Balance }) => {
  const [copied, setCopied] = useState(false);
  const inviteLink = referralCode
    ? `https://s30mocks.com/register?ref=${referralCode}`
    : "";

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };

  if (!referralCode && s30Balance == null) return null;

  return (
    <div className="profile-referral-balance">
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <strong>Your Referral Code:</strong> {referralCode || 'Not assigned'}
        {referralCode && (
          <button
            className="copy-referral-btn"
            style={{ padding: '2px 8px', fontSize: '0.95em', cursor: 'pointer' }}
            onClick={() => handleCopy(referralCode)}
            type="button"
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        )}
      </div>
      <div><strong>S30 Balance:</strong> ₹{s30Balance != null ? s30Balance : 0}</div>
      {referralCode && (
        <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <strong>Invite Link:</strong>
          <input
            type="text"
            value={inviteLink}
            readOnly
            style={{ width: '250px', fontSize: '0.95em' }}
            onFocus={e => e.target.select()}
          />
          <button
            className="copy-referral-btn"
            style={{ padding: '2px 8px', fontSize: '0.95em', cursor: 'pointer' }}
            onClick={() => handleCopy(inviteLink)}
            type="button"
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
      )}
    </div>
  );
};

export default ReferralView;
